// Filter condition values and labels
export const FILTER_CONDITIONS = [
  { value: "eq", label: "Equal to" },
  { value: "neq", label: "Not equal to" },
  { value: "gt", label: "Greater than" },
  { value: "lt", label: "Less than" },
  { value: "in", label: "In" },
  { value: "nin", label: "Not in" },
  { value: "null", label: "Is null" },
  { value: "notnull", label: "Is not null" },
];

// Condition name mapping
export const CONDITION_NAME_MAP = {
  eq: "Equal",
  neq: "Not Equal",
  gt: "Greater",
  lt: "Lesser",
  gte: "GreaterEqual",
  lte: "LesserEqual",
  like: "LIKE",
  null: "IS NULL",
  notnull: "IS NOT NULL",
  in: "IN",
  nin: "NOT IN",
  between: "Between",
};

// Aggregation functions
export const AGG_FUNCTIONS = [
  { value: "SUM", label: "Sum" },
  { value: "COUNT", label: "Count" },
  { value: "AVG", label: "Average" },
  { value: "MIN", label: "Min" },
  { value: "MAX", label: "Max" },
];

export const AI_MODEL_PROVIDERS = [
  { value: "openai", label: "OpenAI" },
  { value: "solutionec", label: "Solutionec Pvt. Ltd."},
  { value: "huggingface", label: "Hugging Face"},
  { value: "ollama", label: "Ollama"},
  { value: "custom", label: "Custom Endpoint"}
];

/** Business semantic layer concept types (must match backend enum BusinessSemanticLayerConceptType). */
export const BUSINESS_SEMANTIC_LAYER_CONCEPT_TYPE = {
  METRIC: "metric",
  DIMENSION: "dimension",
  FILTER: "filter",
};

/** Options for concept type dropdown (label, value). */
export const BUSINESS_SEMANTIC_LAYER_CONCEPT_TYPE_OPTIONS = [
  { value: BUSINESS_SEMANTIC_LAYER_CONCEPT_TYPE.METRIC, label: "Metric" },
  { value: BUSINESS_SEMANTIC_LAYER_CONCEPT_TYPE.DIMENSION, label: "Dimension" },
  { value: BUSINESS_SEMANTIC_LAYER_CONCEPT_TYPE.FILTER, label: "Filter" },
];